// https://github.com/zouhir/lqip-loader#readme
export const getLqipBackgroundImageUrl = (image = null) =>
  image ? `url(${image.src}), url(${image.preSrc})` : "linear-gradient(45deg, gray, lightgray)";
